import { SortEvent } from '@shared/components/table/sort/model/sort.model';
import { Alert } from '@core/domain/model/alerts/alert.model';
import { AlertsListFilter } from '@pages/alerts/alerts-list/model/alerts-list.filter';

export type AlertsState = {
  data: Alert[];
  filter: AlertsListFilter;
  sort: SortEvent;
  error: string | null;
};

export const alertsInitialState: AlertsState = {
  data: [],
  filter: {},
  sort: {
    sortName: 'name',
    sortDir: '',
  },
  error: null,
};
